var SelfServiceJs = (function ($) {

    var specialCharactersRegex = new RegExp("[<>=;/]+");

    function changeInput() {
        var input = $(this);
        if (specialCharactersRegex.test(input.val())) {
            input.siblings('.self-service-input-error-div').show()
        } else {
            input.siblings('.self-service-input-error-div').hide();
        }
    }


    function checkInputs() {
        var validInputs = true;

        $("#selfServiceForm .form-control.required-field").each(function () {
            var input = $(this);
            if (input.val().length == 0) {
                validInputs = false;
                input.siblings(".self-service-input-error-div").show();
            } else {
                input.siblings(".self-service-input-error-div").hide();
            }

        });

        return validInputs;
    }

    function getSelfServicePayload() {
        var payload = {};

        payload["rdnr"] = $("#selfService-rdnr").val();
        payload["token"] = $("#selfService-token").val();
        payload["companyName"] = $("#selfService-companyName").val();
        payload["firstName"] = $("#selfService-firstName").val();
        payload["lastName"] = $("#selfService-lastName").val();
        payload["street"] = $("#selfService-street").val();
        payload["zipCode"] = $("#selfService-zipCode").val();
        payload["city"] = $("#selfService-city").val();
        payload["collectionDate"] = $("#selfService-collectionDate").val();

        return payload;
    }

    function displaySelfServiceErrorMessage(errorCode) {
        if (errorCode instanceof Array) {
            errorCode.forEach(function (item) {
                var errorDiv = "." + item;
                $(errorDiv).show();
            });
        } else {
            switch (errorCode) {
                case "invalid.data":
                    $(".self-service-invalid-data-error").show();
                    break;
                case "invalid.token":
                    $(".self-service-invalid-token-error").show();
                    break;
                default:
                    $(".self-service-default-error").show();
                    break;
            }
        }
    }

    function registerAppointment() {
        $(".self-service-error-div").hide();

        var csrfToken = $("input[name='_csrf']").val();

        $.ajax({
            url: "/self-service/send-appointment",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            headers: {
                "X-CSRF-TOKEN": csrfToken
            },
            data: JSON.stringify(getSelfServicePayload())
        }).done(function () {
            window.location.replace("/self-service/success");
        }).fail(function (data) {
            if (data.responseJSON) {
                displaySelfServiceErrorMessage(data.responseJSON)
            } else {
                displaySelfServiceErrorMessage(data.responseText);
            }
        })
    }

    function initialize() {
        var selfServiceContainer = $(".self-service-container").first();
        if (!selfServiceContainer.length) {
            return;
        }

        $("#selfService-collectionDate").datepicker({
            dateFormat: 'dd.mm.yy',
            minDate: '+1d'
        });

        selfServiceContainer.find("#selfServiceForm .form-control").on('change', changeInput);

        if ($(".self-service-invalid-data").is(":visible")) {
            $("#selfServiceForm .submit-button-container .pure-button").attr('disabled', true);
        }

        selfServiceContainer.find("#selfServiceForm").on("submit", function (event) {
            event.preventDefault();
            if (checkInputs()) {
                registerAppointment();
            }
        })
    }

    return {
        initialize: initialize
    }

})($);

$(function () {
    SelfServiceJs.initialize()
});